module.exports = __webpack_public_path__ + "img/button-home5.96a1892e.jpeg";